import React, { Component } from 'react';
import injectSheet from 'react-jss';
import { Subscribe } from 'unstated';

import HeaderPage from './HeaderPage';
import PromptContainer from '../containers/PromptContainer';
import PromptCard from '../components/PromptCard';
import Footer from '../components/Footer';

const styles = {
  promptCardWrapper: {
    margin: '0 auto',
    width: '37.5rem',
  },
};


class PromptPage extends Component {
  componentDidMount() {
    if (this.props.prompt) {
      this.props.prompt.setup();
    }
  }

  componentWillUnmount() {
    this.props.prompt.destroy();
  }

  renderPromptCard = (selectedParents) => {
    console.log('PromptPage:selectedParents', selectedParents);
    
    return (
      selectedParents.map(cardInfo => (
        <PromptCard
          key={cardInfo._id}
          icon={cardInfo.icon || 'icon-dice'}
          image={cardInfo.image}
          title={cardInfo.title || cardInfo.name}
          description={cardInfo.blurb}
          _id={cardInfo._id}
          cardInfo={cardInfo}
          type={cardInfo.type || cardInfo.parentType}
        />
      ))
    );
  }

  render() {
    const { classes, prompt } = this.props;

    if (!prompt.state.draft) {
      return null; 
    }
    console.log('prompt', this.props);
    
    return (
      <div>
        <HeaderPage titleHeader="Write Prompt" descriptionHeader="This can be shown instead-of or in-addition-to the Topic Blurb." showBtns={false} />
        <div className={classes.promptCardWrapper}>
          {this.renderPromptCard(prompt.state.draft.parents)}
        </div>
        <Footer actionBtnLabel="Continue" backBtnLabel="Back to Selection" to={`/create/${this.props.match.params.slug}/select/addPrompt/addTitle`} back={`/create/${this.props.match.params.slug}/select`} />
      </div>
    );
  }
}

function PromptPageWrapper(props) {
  const { classes } = props;

  return (
    <Subscribe to={[PromptContainer]}>
        { prompt => (
          <div>
          { prompt && ( 
            <PromptPage {...props} classes={classes} prompt={prompt} />
          ) }
          </div>
        )}
    </Subscribe>
  )
}

export default injectSheet(styles)(PromptPageWrapper);



// WEBPACK FOOTER //
// ./src/pages/PromptPage.js